import { Box, CircularProgress, Typography } from "@mui/material";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import viewpaths from "global/constants/ViewPathConstants";
import { selectAuthenticated, selectIsAdmin } from "../../../../redux/authSlice";
import adminProtectedRouteStyles from "./AdminProtectedRoute.styles";

interface AdminProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Protects admin routes: only allows access when user is authenticated AND isAdmin.
 * Redirects to login if not authenticated, to home if authenticated but not admin.
 */
const AdminProtectedRoute = ({ children }: AdminProtectedRouteProps) => {
  const history = useHistory();
  const authenticated = useSelector(selectAuthenticated);
  const isAdmin = useSelector(selectIsAdmin);
  const styles = adminProtectedRouteStyles;

  useEffect(() => {
    if (authenticated === undefined) return;
    if (!authenticated) {
      history.replace(viewpaths.loginViewPath);
      return;
    }
    if (!isAdmin) {
      history.replace(viewpaths.landingViewPath);
    }
  }, [authenticated, isAdmin, history]);

  if (!authenticated) {
    return (
      <Box sx={styles.centered}>
        <CircularProgress size={48} sx={{ color: "#f8481c" }} />
        <Typography sx={styles.message}>Redirecting to login...</Typography>
      </Box>
    );
  }

  if (!isAdmin) {
    return (
      <Box sx={styles.centered}>
        <CircularProgress size={48} sx={{ color: "#f8481c" }} />
        <Typography sx={styles.message}>
          Access denied. Redirecting...
        </Typography>
      </Box>
    );
  }

  return <>{children}</>;
};

export default AdminProtectedRoute;
